export function WebLogoSplash() {
  return (
    <div
      className="web-logo-splash web-logo-splash--fullscreen"
      role="status"
      aria-label="Loading HuaKya"
    >
      <img
        className="web-logo-splash__logo"
        src="/huakya_logo.png"
        alt="HuaKya"
        width={320}
        height={320}
        draggable={false}
      />
      <p className="web-logo-splash__loading" aria-hidden="true">
        Loading
        <span className="web-logo-splash__dots">
          <span>.</span>
          <span>.</span>
          <span>.</span>
        </span>
      </p>
    </div>
  );
}
